<template>
    <div>
        <DevTitle style="display: none"/>
        <Hello/>
        <Resume :projects="projects" :skills="skills" :about="about"/>
        <Footer/>
    </div>
</template>

<script>
import Vue from 'vue'

import Hello from "/src/components/Hello";
import Resume from "/src/components/Resume/Resume";
import Footer from "/src/components/Footer";
import DevTitle from "/src/components/DevTitle";
import {LayoutPlugin} from 'bootstrap-vue'

export default {
    name: "HomeView",
    components: {Hello, Resume, Footer, DevTitle},
    inject: ["loadingScreen"],
    created() {
        Vue.use(LayoutPlugin)
    },
    mounted() {
        document.onreadystatechange = () => this.documentStateChanges(document.readyState, this)
    },
    methods: {
        // Build a URL to a resource in the public folder that respects the build publicPath / BASE_URL.
        publicUrl(path) {
            const base = process.env.BASE_URL || '/'; // Vue CLI injects this.
            if (path.startsWith('/')) path = path.slice(1);
            if (!base.endsWith('/')) return `${base}/${path}`;
            return base + path;
        },

        async fetchJsonSequential(url) {
            const res = await fetch(url, {cache: 'no-cache'});
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            return await res.json();
        },

        documentStateChanges: async (state, component) => {
            if (state !== "complete") return;

            let data = {};
            try {
                // Try canonical location(s). Adjust these if you restructure public folder.
                const base = component.publicUrl('');
                const fallback = base + 'cv_data.json';   // existing file in public root
                data = await component.fetchJsonSequential(fallback);
            } catch (error) {
                console.error('Unable to load any data JSON. Provide public/cv_data.json', error);
                data = {about: '', skills: [], projects: [], company: {}}; // fail-safe
            }

            const expYear = new Date().getFullYear() - 2014;

            if (data.about) {
                component.about = data.about.replace("${getExperienceYears()}", expYear)
            }
            if (Array.isArray(data.skills)) component.skills = data.skills;
            if (Array.isArray(data.projects)) {
                component.projects = data.projects.map((p) => {
                    if (data.company && p.company && data.company[p.company]) {
                        p.company = data.company[p.company]
                    }
                    return p
                })
            }

            component.cvPath = component.publicUrl('cv.pdf');
            component.loadingScreen.enabled = false;
        }
    },
    data() {
        return {
            projects: [],
            skills: [],
            about: "about",
            cvPath: this ? this.publicUrl('cv.pdf') : '/cv.pdf'
        }
    },
}
</script>

<style scoped lang="scss">
@import "src/assets/media-queries";

</style>